var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConcurrent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.1333 99.4257C77.735 88.1646 87.7125 77.2554 101.348 78.1252C112.938 78.8622 122.285 88.9282 121.926 100.515C121.535 113.243 111.591 122.187 99.7013 122.187C87.427 122.187 77.9209 112.506 78.1267 99.4257H78.1333Z",
    fill: "#E98432"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_108_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.6666 100L26.3333 100M69.6666 100L50.1666 119.5M69.6666 100L50.1666 80.5",
    stroke: "#F4C135",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_108_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.333 100L173.667 100M130.333 100L149.833 119.5M130.333 100L149.833 80.5",
    stroke: "#F4C135",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98 69.6667L98 26.3334M98 69.6667L117.5 50.1667M98 69.6667L78.5 50.1667",
    stroke: "#F4C135",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 130.333L98 173.667M98 130.333L117.5 149.833M98 130.333L78.5 149.833",
    stroke: "#F4C135",
    strokeWidth: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_47"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_108_47"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(22 126) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_108_47"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 178 126)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcurrent);
export default __webpack_public_path__ + "static/media/Concurrent.9ffd979763104bbe7573c2384016406a.svg";
export { ForwardRef as ReactComponent };